import { Check } from '@mui/icons-material';
import { Box, Button, Container, Paper } from '@mui/material';
import { ImageUploader, Subheader } from 'components';
import useAcademies from 'hooks/useAcadamies';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AcademyForm from './AcademyForm';
import { useAlerts, usePartners } from 'hooks';
import { validateAcademy } from 'validations/academy';

const AcademyEdit = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { partners, findPartners, query, page, sortKey, sortDirection } =
		usePartners({});
	const {
		findAcademy,
		academy,
		uploadFile,
		deleteFile,
		handleChange,
		updateAcademy
	} = useAcademies({ id: id });
	const { showAlertSuccess, showAlertError } = useAlerts();

	const handleSaveClick = async () => {
		const valid = validateAcademy(academy);
		if (!valid.isValid) {
			showAlertError(valid.messages[0]);
			return;
		}

		if (!academy.partner_id) {
			showAlertError('select a partner for the academy');
			return;
		}

		await updateAcademy(academy);
		showAlertSuccess('Academy has been updated');
		navigate(`/academies/${academy.id}`);
	};

	const handleUpload = async (file, type) => {
		await uploadFile(file, type);
		findAcademy(id);
	};

	const handleDelete = async (type) => {
		await deleteFile(type);
		findAcademy(id);
	};

	useEffect(() => {
		if (id) findAcademy(id);
	}, [id]);
	useEffect(() => {
		findPartners(
			{
				...query,
				sort_key: sortKey,
				sort_direction: sortDirection
			},
			page
		);
	}, [query, page, sortKey, sortDirection]);
	return (
		<>
			<Subheader
				title="Edit Academy"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Update Academy
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<center>
							<ImageUploader
								label="Academy Image Upload"
								imageUrl={academy?.image_url}
								handleUpload={(file) => handleUpload(file, 'image_url')}
								handleDelete={() => handleDelete('image_url')}
							/>
						</center>
						<AcademyForm
							academy={academy}
							handleChange={handleChange}
							partners={partners}
						/>
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default AcademyEdit;
